import axios from "axios";
import objectToFormData from "../utils/objectToFormData";
import { API } from "../constants";
import { apiUrl } from "./lt-api";

axios.defaults.baseURL = API;

const defaultHeaders = {
  crossDomain: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    withCredentials: true
  }
};

const getConfigWithToken = (method = "get", extraConfig = {}) => {
  const token = JSON.parse(localStorage.getItem('token'));
  return {
    ...defaultHeaders,
    method,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
    },
    ...extraConfig
  };
};

export function getCategoriesMapping(id) {
  return axios({
    ...getConfigWithToken("get"),
    url: `${apiUrl}etl/scrapers/${id}/categories_mapping`
  });
}

export function updateCategoriesMappingDataRequest(id, payload) {
  const formData = objectToFormData(payload);
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}etl/scrapers/${id}/update_categories_mapping`,
    data: formData
  });
}

export function deleteCategoriesMappingDataRequest(id, payload) {
  const formData = objectToFormData(payload);
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}etl/scrapers/${id}/delete_categories_mapping`,
    data: formData
  });
}
